import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { Box, Dialog, DialogContent, Stack, Typography, dialogContentClasses } from '@mui/material';
import CloseIcon from 'mdi-material-ui/Close';
import { IconButton } from '../IconButton';
import { translateSizeToMaterialSize } from '../../utils/translate-size';
/**
 * ModalBase is a raw implementation of a modal that allows custom composition of the header and Footer. You most likely
 * do not actually want to use this component, and should use <Modal /> instead. If you find yourself using ModalBase,
 * consult with your designer to make sure your usecase actually requires it, and ignoring the consistency provided by
 * Modal is actually required.
 */ export const ModalBase = /*#__PURE__*/ forwardRef(function ModalBase({ isOpen, children, title, TitleIcon, Footer, onClose, size = 'medium', badge }, ref) {
    const hasHeader = !!title || !!onClose || !!badge;
    const hasFooter = !!Footer;
    return /*#__PURE__*/ _jsxs(Dialog, {
        ref: ref,
        open: isOpen,
        onClose: onClose,
        scroll: "paper",
        keepMounted: false,
        fullWidth: true,
        maxWidth: translateSizeToMaterialSize(size),
        "aria-labelledby": "modal-title",
        fullScreen: size === 'fullScreen',
        children: [
            hasHeader && /*#__PURE__*/ _jsxs(Box, {
                padding: (theme)=>theme.spacing(1, 2),
                children: [
                    /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            TitleIcon && /*#__PURE__*/ _jsx(TitleIcon, {
                                fontSize: "small"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h3",
                                minHeight: "24px",
                                id: "modal-title",
                                children: title
                            }),
                            badge && // Div needed around badge for vertical centering to work because badge is usually an inline
                            // element.
                            /*#__PURE__*/ _jsx("div", {
                                children: badge
                            })
                        ]
                    }),
                    onClose && /*#__PURE__*/ _jsx(IconButton, {
                        "aria-label": "Close",
                        onClick: onClose,
                        sx: (theme)=>({
                                position: 'absolute',
                                top: theme.spacing(0.5),
                                right: theme.spacing(0.5)
                            }),
                        children: /*#__PURE__*/ _jsx(CloseIcon, {})
                    })
                ]
            }),
            children && /*#__PURE__*/ _jsx(DialogContent, {
                dividers: hasHeader || hasFooter,
                sx: {
                    padding: 0,
                    [`&.${dialogContentClasses.dividers}`]: {
                        // Remove the bottom border "divider" when a footer is not present.
                        borderBottom: !hasFooter ? 'none' : undefined
                    }
                },
                children: children
            }),
            Footer
        ]
    });
});

//# sourceMappingURL=ModalBase.js.map